import request from '../utils/request';

const WITH_CREDS = { withCredentials: true };

export async function getPropertyImageUrl(hostId, propertyId, propertySource) {
  try {
    if (!hostId || !propertyId) {
      console.log('Missing hostId or propertyId:', { hostId, propertyId });
      return null;
    }

    // Try query-based approach first
    const params = new URLSearchParams();
    params.append('hostId', hostId);
    params.append('propertyId', propertyId);

    console.log('Fetching image for property:', { hostId, propertyId, propertySource });
    const { data } = await request.get(`/property-images?${params.toString()}`, WITH_CREDS);
    console.log('API response:', data);
    
    // Handle array response - look for the specific property
    if (data.success && Array.isArray(data.data)) {
      const propertyImage = data.data.find(img => 
        img.propertyId === propertyId || img.propertyId === String(propertyId)
      );
      
      if (propertyImage?.imageUrl) {
        console.log('Found image URL:', propertyImage.imageUrl);
        return propertyImage.imageUrl;
      }
    }
    
    // Handle single object response (fallback)
    if (data.success && data.data?.imageUrl) {
      console.log('Found image URL:', data.data.imageUrl);
      return data.data.imageUrl;
    }

    console.log('No image URL found in response');
    return null;
  } catch (error) {
    console.error('Error fetching property image:', error);
    return null;
  }
}

export async function fetchAllPropertyImages(hostId) {
  try {
    if (!hostId) {
      console.log('Missing hostId');
      return [];
    }

    console.log('Fetching all images for host:', hostId);
    const { data } = await request.get(`/property-images?hostId=${hostId}&includeFallback=true`, WITH_CREDS);
    console.log('Batch API response:', data);
    
    if (data.success && Array.isArray(data.data)) {
      console.log(`Found ${data.data.length} images for host`);
      return data.data;
    }

    console.log('No images found in batch response');
    return [];
  } catch (error) {
    console.error('Error fetching all property images:', error);
    return [];
  }
}